<template>
    <div class="bgc">
        <div class="cor_divO">
            <div class="cor_divOne">
                <span>申请时间：</span><label>{{dataorderSn.createTime }}</label>
            </div>
            <div>
                <span style="letter-spacing:4px">订单号：</span><label>{{dataorderSn.orderSn }}</label>
            </div>
            <div>
                <span>申请单号：</span><label>{{dataorderSn.returnSn }}</label>
            </div>
            <div>
                <span>售后类型：</span><label v-if="dataorderSn.type===1">退款</label><label v-if="dataorderSn.type===2">退款</label><label v-else-if="dataorderSn.type===3">退货</label>
            </div>
            <div>
                <span>处理状态：</span>
                <label v-if="dataorderSn.status===0">可申请</label>
                <label v-else-if="dataorderSn.status===1">待处理</label>
                <label v-else-if="dataorderSn.status===2">已通过</label>
                <label v-else-if="dataorderSn.status===3">已拒绝</label>
                <label v-else-if="dataorderSn.status===4">处理中</label>
                <label v-else-if="dataorderSn.status===5">已完成</label>
            </div>
        </div>
        <div class="cor_view">
            <span  v-if="dataorderSn.type==1">申请退款的商品</span>
            <span  v-if="dataorderSn.type==2">申请退款的商品</span>
            <span  v-if="dataorderSn.type==3">申请退货的商品</span>
        </div>
          <div class="orderinfoTopcentertwo" v-if="dataorderSnShow" >
          <div >
          <dl>
            <dt style="float:left;margin-right:8px;"><img :src="dataorderSn.productPic " alt=""></dt>
            <dd>
              <div class="orderinfoTopcentertwodd" style="display:flex;justify-content:space-between;color:#333333;">
                <div>
                  <span class="ellpis">{{dataorderSn.productName }}</span>
                </div>
                <div style="padding-right:10px;">x{{dataorderSn.productCount }}</div>
              </div>
              <div class="orderinfoTopcentertwoddTwo">{{dataorderSn.productAttr }}</div>
              <div class="orderinfoTopcentertwoddThree">
                <div style="color:#333333;">￥{{dataorderSn.productPrice }}</div>
              </div>
            </dd>
          </dl>
          </div>
        </div>
        <div class="orderinfoTopcentertwo" v-else>
          <div  v-for="(item,index) in data" :key="index">
          <dl>
            <dt style="float:left;margin-right:8px;"><img :src="item.productPic " alt=""></dt>
            <dd>
              <div class="orderinfoTopcentertwodd" style="display:flex;justify-content:space-between;color:#333333;">
                <div>
                  <span class="ellpis">{{item.productName }}</span>
                </div>
                <div style="padding-right:10px;">x{{item.productQuantity }}</div>
              </div>
              <div class="orderinfoTopcentertwoddTwo">{{item.productAttr }}</div>
              <div class="orderinfoTopcentertwoddThree">
                <div style="color:#333333;">￥{{item.productPrice }}</div>
              </div>
            </dd>
          </dl>
          </div>
        </div>
        <div class="cor_view">申请信息</div>
        <div class="cor_center">
            <div class="cor_mt">
                <span>原因：</span><label>{{dataorderSn.reason }}</label>
            </div>
            <div class="cor_mt">
                <span>描述：</span><label v-if="dataorderSn.description!=''">{{dataorderSn.description }}</label><label v-else>您未对商品进行评论描述</label>
            </div>
            <div class="cor_mt">
                <div><span>照片：</span><label v-if="dataorderSn.pic===''">未上传商品图</label></div>
                <div v-if="dataorderSn.pic!=''">
                    <div style="display: flex;justify-content: flex-start;" >
                      <div v-for="(ele,i) in picArr(pic)" :key="i">
                        <img :src="ele"  alt=""  class="cor_img" @click="DialogOpen(i)">
                      </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { afterInfo, orderInfo } from '@/request/api'
import { ImagePreview } from 'vant'
export default {
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component
  },
  data() {
    return {
      data: [],
      pic: '',
      dataorderSn: {},
      dataorderSnShow: true
    }
  },
  methods: {
    picArr (pic) {
      return pic.split(',')
    },
    DialogOpen(i) {
      // var _thispic = this.pic.split(',')
      ImagePreview({
        images: this.pic.split(','),
        startPosition: i,
        closeOnPopstate: true
      })
    }
  },
  created() {
    if (this.$route.query.MultiCommodity) {
      this.dataorderSnShow = false
      afterInfo({ returnId: this.$route.query.id }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.dataorderSn = res.data
          this.pic = res.data.pic
          return res.data.orderId
        }
      }).then(res => {
        console.log(res)
        orderInfo(res).then(res => {
          console.log(res.data.orderItemList)
          this.data = res.data.orderItemList
        })
      }).catch(res => {
        console.log(res)
      })
    } else {
      // 单个商品退款
      this.dataorderSnShow = true
      afterInfo({ returnId: this.$route.query.id }).then(res => {
        if (res.code === 200) {
          console.log(res.data)
          this.dataorderSn = res.data
          this.pic = res.data.pic
        }
      }).catch(res => {
        console.log(res)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.bgc{
    min-height: 100vh;
    background-color: #F2F2F2;
}
    .cor_divO{
        width:750px;
        height:290px;
        background:rgba(255,255,255,1);
        font-size: 28px;
        div{
            line-height: 55px;
            padding-left: 32px;
        }
        .cor_divOne{
            margin-top: 20px;
        }
        span{
            color: #666666;
        }
        label{
            color: #333333;
        }
    }
    .cor_view{
        height: 80px;
        background-color: #F2F2F2;
        display: flex;
        align-items: center;
        padding-left: 30px;
        font-size: 28px;
    }
    .orderinfoTopcentertwo {
        border-bottom: 0.5px solid #EEEEEE;/*no*/
        background-color: #fff;
      dl{
          padding-top: 20px;
          height: 206px;
        dt{
          width: 150px;
          height: 150px;
          margin-top: 20px;
          margin-left: 30px;
          img{
            width: 100%;
            height: 100%;
          }
        }
        dd{
            float: left;
            margin-top: 20px;
            width: 550px;
          .orderinfoTopcentertwodd{
            font-size: 28px;
          }
          .orderinfoTopcentertwoddTwo{
            font-size: 24px;
            color: #999999;
            padding-left: 10px;
            padding-top: 10px;
          }
          .orderinfoTopcentertwoddThree{
            margin-top: 10px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 34px;
            div{
              font-size: 30px;
              margin-right: 40px;
            }
            s{
              font-size: 27px;
              padding-top: 5px;
            }
          }
        }
      }
    }
    .cor_center{
        width: 100%;
        background:rgba(255,255,255,1);
        padding-bottom: 40px;
        .cor_mt{
            padding-top: 30px;
            padding-left: 27px;
        }
        .cor_img{
            width: 150px;
            height: 150px;
            border-radius:5px;
            margin-right: 30px;
        }
        span{
            color: #666666;
            font-size: 28px;
        }
        .elimpls{
            overflow : hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        label{
            color: #333333;
            font-size: 28px;
        }
    }
    .ellpis{
      overflow : hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
</style>
